import { when } from "./functions";

export const getExtension = (filename: string): string | undefined => {
  const index = filename.lastIndexOf(".");
  return index > 0 ? filename.substring(index + 1).toLowerCase() : undefined;
};

export const isExtensionPdf = (filename: string) => getExtension(filename) === "pdf";
export const isExtensionImage = (filename: string) =>
  when(getExtension(filename), (ext) => ["jpg", "jpeg", "gif", "png"].includes(ext));

export const isExtensionOffice = (filename: string) =>
  when(getExtension(filename), (ext) =>
    ["doc", "docx", "ppt", "pptx", "xls", "xlsx", "odt", "ods", "odp"].includes(ext),
  );

export const isExtensionJson = (filename: string) => getExtension(filename) === "json";

export const isExtensionXml = (filename: string) => getExtension(filename) === "xml";

export const isSupportedFileTypeForPreview = (filename: string | undefined): boolean =>
  filename !== undefined &&
  (isExtensionPdf(filename) ||
    isExtensionImage(filename) ||
    isExtensionJson(filename) ||
    isExtensionXml(filename));
